import type { $Fetch } from 'ofetch';
import type { Pipeline, PipelineStage, PipelineCommand } from '@/domain/model/Pipeline';
import type { PipelineGateway } from '@/application/port/out/PipelineGateway';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const PATH = '/api/v1/commerce/pipelines';

export class HttpPipelineGateway implements PipelineGateway {
  constructor(private readonly client: $Fetch) {}

  async list(): Promise<Pipeline[]> {
    const res = await this.client<ApiResponse<Pipeline[]>>(PATH, { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }

  async get(id: string): Promise<Pipeline> {
    const res = await this.client<ApiResponse<Pipeline>>(`${PATH}/${encodeURIComponent(id)}`, { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }

  async listStages(pipelineId: string): Promise<PipelineStage[]> {
    const res = await this.client<ApiResponse<PipelineStage[]>>(
      `${PATH}/${encodeURIComponent(pipelineId)}/stages`, { method: 'GET' },
    );
    assertApiSuccess(res);
    return res.data;
  }

  async create(cmd: PipelineCommand): Promise<Pipeline> {
    const res = await this.client<ApiResponse<Pipeline>>(PATH, { method: 'POST', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }

  async update(id: string, cmd: PipelineCommand): Promise<Pipeline> {
    const res = await this.client<ApiResponse<Pipeline>>(
      `${PATH}/${encodeURIComponent(id)}`, { method: 'PUT', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }

  async deactivate(id: string): Promise<void> {
    // DELETE 204 No Content.
    await this.client(`${PATH}/${encodeURIComponent(id)}`, { method: 'DELETE' });
  }
}
